// Small horizontal tab-bar for the admin section. Renders inside every admin
// page so the operator can hop between Analytics and Students without going
// back to the dashboard.
import { NavLink } from "react-router-dom";
import { BarChart3, Users } from "lucide-react";

const linkBase =
    "inline-flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-colors";
const active = "bg-[#2D5D4E] text-[#FAF9F6]";
const inactive = "bg-white text-[#1C2321] border border-[#E5E7E2] hover:bg-[#E8E2D2]";

export default function AdminNav() {
    return (
        <nav className="flex flex-wrap gap-2 mb-8" data-testid="admin-nav" aria-label="Admin sections">
            <NavLink
                to="/app/admin/analytics"
                end
                data-testid="admin-nav-analytics"
                className={({ isActive }) => `${linkBase} ${isActive ? active : inactive}`}
            >
                <BarChart3 className="w-4 h-4" strokeWidth={1.8} /> Analytics
            </NavLink>
            <NavLink
                to="/app/admin/students"
                end
                data-testid="admin-nav-students"
                className={({ isActive }) => `${linkBase} ${isActive ? active : inactive}`}
            >
                <Users className="w-4 h-4" strokeWidth={1.8} /> Students
            </NavLink>
        </nav>
    );
}
